import tree from '../state';
import * as categoryService from '../services/categoryService';

export const enterCategoryAction = ({ params, location }, replace, callback) => {
    tree.set('loading', true);

    let pathName = location.pathname;
    if (pathName === '/fireproof-safes') {
        pathName = '/fire-safes';
    }


    categoryService.getCategory(pathName.split('/')[1]).then(category => {
        console.log('category', category);
        tree.set('category', category);
        tree.set('loading', false);
        callback();
    });
};


// WEBPACK FOOTER //
// ./src/actions/categoryActions.js